import { FC } from 'react';
import ConversationHandler from '../Components/Conversation/ConversationHandler';
import SurveyHandler from '../Components/Survey/SurveyHandler';

export const PageChat: FC = () => {
    return <>
        <ConversationHandler />
        <SurveyHandler />
    </>;
};
